var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoyaltyManagementActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#2572B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.5h-1V7a1.001 1.001 0 0 0-1-1H9a1.001 1.001 0 0 0-1 1v.5H7a1.001 1.001 0 0 0-1 1V10a2.002 2.002 0 0 0 2 2h.161a4.084 4.084 0 0 0 3.339 2.967V17H9v1h6v-1h-2.5v-2.034A3.983 3.983 0 0 0 15.87 12H16a2.003 2.003 0 0 0 2-2V8.5a1.001 1.001 0 0 0-1-1zM8 11a1.001 1.001 0 0 1-1-1V8.5h1V11zm7 0a3 3 0 0 1-3.093 2.999A3.1 3.1 0 0 1 9 10.853V7h6v4zm2-1a1.002 1.002 0 0 1-1 1V8.5h1V10z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyManagementActiveIcon);
export default __webpack_public_path__ + "static/media/loyaltyManagementActiveIcon.e24dd9973b94548b3e2a74762eb2c880.svg";
export { ForwardRef as ReactComponent };